import { BaseGridDocumentComponent } from '@dato-pages/base/base-grid-document-component';
import { Component, } from '@angular/core';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';

import { EnumSystemTypes } from '@dato-proxy/enums';
import { Globals } from '../../../../_globals';
import { Delivery } from '@dato-proxy/entities/delivery.entity';

@Component({
    providers: ServiceBagServices,
    selector: 'app-delivery-grid',
    templateUrl: './delivery-grid.component.html',
    styleUrls: ['./delivery-grid.component.scss']
})
export class DeliveryGridComponent extends BaseGridDocumentComponent<Delivery> {
    constructor(A: ServiceBagService) {
        super(A, 'DeliveryGridComponent', Delivery);
    }

    public IsLandlord() { return Globals.SystemOption && Globals.SystemOption.SystemType === EnumSystemTypes.Landlord; }
}
